var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAddLabel = function SvgAddLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.497 10H3.17l-1.333 3.333H.4L4.667 2.667H6l4.267 10.666H8.83L7.497 10zm-.533-1.333L5.334 4.59 3.702 8.667h3.261zM14 8.357V8h1.333v5.333H14v-.356a2.666 2.666 0 110-4.62zM12.667 12a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add-label_svg__clip0_261_12028"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgAddLabel;